// extracted by mini-css-extract-plugin
export default {"viewModeSwitch":"ViewModeSwitch_viewModeSwitch__+75ej"};